<template>
    <v-card>
        <v-card-title>
            <slot name="middle-title"></slot>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" @input="onToggleDialog($event)" max-width="600px" :retain-focus="false">
                <template v-slot:activator="{ on }">
                    <v-btn color="primary" dark class="mb-2" v-on="on">Nuevo</v-btn>
                </template>
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ formTitle }}</span>
                    </v-card-title>
                    <v-card-text>
                        <v-container>
                            <v-row>
                                <v-col cols="12" sm="12">
                                    <slot
                                        name="form"
                                        :localEditedItem="localEditedItem"
                                        :opened="dialog"
                                        :afterDialogOpen="afterDialogOpen"
                                    ></slot>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-card-text>

                    <v-card-actions>
                        <div class="flex-grow-1"></div>
                        <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
                        <v-btn color="blue darken-1" text @click="save">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-card-title>
        <v-data-table :headers="headers" :items="filteredItems" :inputs="inputs">
            <template v-slot:header="{ header }">
                <tr class="grey lighten-3">
                    <th v-for="header in headers" :key="header.text">
                        <div v-if="filters.hasOwnProperty(header.value)">
                            <v-select
                                v-model="filters[header.value].value"
                                v-if="header.searchType == 'boolean'"
                                :items="['Todos', 'Sí', 'No']"
                            ></v-select>
                            <v-text-field v-else v-model="filters[header.value].value"></v-text-field>
                        </div>
                    </th>
                </tr>
            </template>
            <template v-slot:top></template>
            <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small class="mr-2" @click="deleteItem(item)">mdi-delete</v-icon>
                <slot name="actions" v-bind:item="item"></slot>
            </template>
            <template v-slot:no-data>
                <p>No hay elementos</p>
            </template>

            <!-- fix hacker para hacer funcionar el valor boolean de ponderables -->
            <template v-slot:item.libre="{ item }">
                <v-icon>
                    {{ item.libre ? "mdi-checkbox-marked" : "mdi-checkbox-blank-outline" }}
                </v-icon>
            </template>

            <!-- fix hacker para hacer funcionar el color de los ponderables -->
            <template v-slot:item.color="{ item }">
                <div
                    class="d-flex align-center justify-center"
                    v-bind:style="{ backgroundColor: item.color, minHeight: '20px', borderRadius: '3px' }"
                ></div>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            dialog: false,
            afterDialogOpen: false,
            search: "",
            editedIndex: -1,
            localEditedItem: { ...this.editedItem },
            localDefaultItem: { ...this.defaultItem },
            filters: this.headers.reduce((prev, curr) => {
                if (curr.disableSearch) return
                const filter = {
                    value: curr.searchType == "boolean" ? "Todos" : "",
                    type: curr.searchType || "text"
                }
                prev[curr.value] = filter
                return prev
            }, {})
        }
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nuevo" : "Editar"
        },
        filteredItems() {
            return this.items.filter(item => {
                return Object.keys(this.filters).every(f => {
                    const filterValue = this.filters[f].value
                    if (this.filters[f].type == "text") {
                        if (filterValue == "") return true
                        if (item[f] == null || item[f] == "") return false
                        return item[f] ? ("" + item[f]).toLowerCase().includes(filterValue.toLowerCase()) : true
                    } else if (this.filters[f].type == "boolean") {
                        if (filterValue == "Todos") return true
                        return !!item[f] == { Sí: true, No: false }[filterValue]
                    } else return true
                })
            })
        }
    },
    props: ["inputs", "headers", "items", "editedItem", "defaultItem", "modelService"],
    methods: {
        columnValueList(val) {
            return this.items.map(d => d[val])
        },
        onToggleDialog(opened) {
            if (opened) {
                this.afterDialogOpen = false
                setTimeout(() => {
                    this.afterDialogOpen = true
                }, 200)
            } else {
                this.afterDialogOpen = false
            }
        },
        editItem(item) {
            this.editedIndex = this.items.indexOf(item)
            this.localEditedItem = Object.assign({}, item)
            this.dialog = true
            this.onToggleDialog(this.dialog)
            this.$emit("edit", item)
        },
        deleteItem(item) {
            const index = this.items.indexOf(item)
            confirm("¿Estas seguro que deseas borrar este elemento junto con todos sus recursos asociados?") &&
                this.modelService.destroy(item.id).then(() => this.items.splice(index, 1))
        },
        close() {
            this.dialog = false
            this.onToggleDialog(this.dialog)
            this.$emit("closeDialog")
            setTimeout(() => {
                this.localEditedItem = Object.assign({}, this.localDefaultItem)
                this.editedIndex = -1
            }, 300)
        },
        save() {
            if (this.editedIndex > -1) {
                const editedIndex = this.editedIndex
                Object.assign(this.items[editedIndex], this.localEditedItem)
                this.modelService.update(this.localEditedItem).then(updatedItem => {
                    Object.assign(this.items[editedIndex], updatedItem)
                    this.$emit("updated", this.items[editedIndex])
                })
            } else {
                this.modelService.create(this.localEditedItem).then(item => this.items.push(item))
            }
            this.close()
        }
    }
}
</script>
